<div class="container order-confirmation">
  <div class="row order-confirmation-custom-row">
    <div class="order-confirmation-img"></div>
  </div>
  <div class="row order-confirmation-custom-row order-confirmation-number">
    <h3 class="confirmation-message">
      {{ "orderCheckOut.placeSuccess" | cxTranslate }}
    </h3>
    <h3  *ngIf="!quoteUpdate" class="confirmation-message">
      {{ "orderCheckOut.order" | cxTranslate }} : {{ confirmCode }}
    </h3>
    <h3  *ngIf="quoteUpdate" class="error-message">
      {{ "orderCheckOut.orderErrorMsg" | cxTranslate }}
    </h3>
  </div>
  <div *ngIf="!quoteUpdate" class="row custom-margin-top order-confirmation-custom-row order-confirmation-summary">
    <p class="order-summary custom-margin-bottom">
      {{ "orderCheckOut.orderEmail" | cxTranslate }} {{ confirmEmail }}
    </p>
    <p class="order-summary">
      {{ "orderCheckOut.downloadDetails" | cxTranslate }}
    </p>
  </div>
  <div *ngIf="quoteUpdate" class="row custom-margin-top order-confirmation-custom-row order-confirmation-summary">
  <p class="order-summary custom-margin-bottom">
    {{ "orderCheckOut.supportErrorTeam" | cxTranslate }} 
  </p>
  <p class="order-summary">
    {{ "orderCheckOut.orderErrorEmail" | cxTranslate }} {{ confirmEmail }}
  </p>
</div>
  <div
    *ngIf="!quoteUpdate"
    (click)="downloadPdf()"
    class="row order-confirmation-custom-row order-confirmation-download-btn"
  >
    <button type="button" class="vs-primary-btn custom-primary-btn">
      <i class="material-icons-outlined custom-material-icons">save_alt </i>
      {{ "orderCheckOut.downloadPdf" | cxTranslate }}
    </button>
  </div>
  <div
    class="row custom-margin-contact-top order-confirmation-custom-row order-confirmation-contactUs"
  >
    <p class="order-help custom-margin-bottom">
      {{ "orderCheckOut.needHelp" | cxTranslate }}
    </p>
    <p class="order-help">
      {{ "orderCheckOut.please" | cxTranslate }}
      <span
        ><a
          [routerLink]="['/contactus']"
          [queryParams]="{ page: 'order-confirmation' }"
          class="contact-us"
          >{{ "orderCheckOut.contactUs" | cxTranslate }}</a
        ></span
      >
      {{ "orderCheckOut.detailOfQuote" | cxTranslate }}
    </p>
  </div>
</div>
